import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MinimumOrderQtyComponent from "@tCooneyBrothers/Components/MinimumOrderQty";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

const ProductDetailsMinOrderQty: React.FC<Props> = ({ product }) => {
    if (!product.detail || !product.minimumOrderQty) {
        return null;
    }

    const showDiscontinuedTag = product.properties?.discontinuedProduct?.toLowerCase() === "true" || false;
    if (showDiscontinuedTag) {
        return null;
    }
    return (
        <>
            {product.minimumOrderQty > 1 && (
                <MinimumOrderQtyComponent minimumOrderQuantity={product.minimumOrderQty}></MinimumOrderQtyComponent>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsMinOrderQty),
    definition: {
        displayName: "MinOrderQty",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
